import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import FacilityHoursList, { hoursShape } from './FacilityHoursList';

import './facilityHours.scss';

export function FacilityHours({ className, accessHours, officeHours, showFullDay }) {
	return (
		<div className={classnames(className, 'facility-hours')}>
			<div className="facility-hours-container">
				<FacilityHoursList
					hours={officeHours}
					listTitle="Office hours"
					showFullDay={showFullDay}
				/>
				<FacilityHoursList
					hours={accessHours}
					listTitle="Access hours"
					showFullDay={showFullDay}
				/>
			</div>
		</div>
	);
}

FacilityHours.propTypes = {
	className: PropTypes.string,
	accessHours: hoursShape,
	officeHours: hoursShape,
	showFullDay: PropTypes.bool
};

FacilityHours.defaultProps = {
	showFullDay: false
};

export default FacilityHours;
